import { urlHelper } from 'src/app/helpers';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import {
  BlockStatisticCreateType,
  BlockStatisticDataType,
  BlockStatisticLookupDataType,
  BlockStatisticLookupType,
  BlockStatisticUpdateType,
} from 'src/app/redux/blockStatistic/blockStatisticSlice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const blockStatisticSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBlockStatistics: builder.query<BlockStatisticLookupType, BlockStatisticLookupDataType | void>({
      query: (params?: BlockStatisticLookupDataType) => ({
        url: finalUrlsConfig().surfer.blockStatistic.lookup,
        params: urlHelper.getLookupQuery(params),
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.rows.map(({ id }) => ({
                type: 'BlockStatistics' as const,
                id,
              })),
              { type: 'BlockStatistics', id: 'LIST' },
            ]
          : [{ type: 'BlockStatistics', id: 'LIST' }],
    }),
    createBlockStatistic: builder.mutation<BlockStatisticDataType, BlockStatisticCreateType>({
      query: (data) => ({
        url: finalUrlsConfig().surfer.blockStatistic.create,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (_result, _error, _data) => [{ type: 'BlockStatistics', id: 'LIST' }],
    }),
    updateBlockStatistic: builder.mutation<BlockStatisticDataType, BlockStatisticUpdateType>({
      query: (data) => ({
        url: `${finalUrlsConfig().surfer.blockStatistic.update}/${data.id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: (_result, _error, data) => [{ type: 'BlockStatistics', id: data.id }],
    }),
    deleteBlockStatistic: builder.mutation<void, string>({
      query: (id: string) => ({
        url: `${finalUrlsConfig().surfer.blockStatistic.delete}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, id) => [{ type: 'BlockStatistics', id }],
    }),
    startPrediction: builder.mutation<void, void>({
      query: () => ({
        url: `${finalUrlsConfig().surfer.blockStatistic.startPrediction}`,
        method: 'POST',
      }),
      invalidatesTags: (_result, _error) => [{ type: 'BlockStatistics' }],
    }),
  }),
});

export const {
  useDeleteBlockStatisticMutation,
  useGetBlockStatisticsQuery,
  useCreateBlockStatisticMutation,
  useUpdateBlockStatisticMutation,
  useStartPredictionMutation,
} = blockStatisticSlice;
